module.exports = __webpack_public_path__ + "img/um.aefba3fe.svg";